import { DescribedAgreementRuleCondition } from 'bff';
import { useTranslations } from 'i11n';
import { Badge } from 'ui';

/** A rule's conditions read as sentences: attribute, operator and the values by their label. */
export const AgreementRuleConditionList = ({
  conditions,
  emptyMessage,
}: {
  conditions: DescribedAgreementRuleCondition[];
  emptyMessage: string;
}) => {
  const t = useTranslations('offer.agreement');

  if (conditions.length === 0)
    return <p className='text-sm text-muted-foreground'>{emptyMessage}</p>;

  return (
    <ul className='flex flex-col gap-2'>
      {conditions.map((condition, position) => (
        <li
          key={`${condition.attribute}-${position}`}
          className='flex flex-wrap items-center gap-1.5 rounded-md border px-3 py-2 text-sm'
        >
          <span className='font-medium text-foreground'>
            {t(
              `attributes.${condition.attribute}`,
              undefined,
              condition.attribute,
            )}
            {condition.name && (
              <span className='font-mono text-xs text-muted-foreground'>
                {' '}
                ({condition.name})
              </span>
            )}
          </span>
          <span className='text-muted-foreground'>
            {t(
              `operators.${condition.operator}`,
              undefined,
              condition.operator,
            )}
          </span>
          {condition.value_labels.map((label, index) => (
            <Badge key={`${label}-${index}`} variant='neutral'>
              {label}
            </Badge>
          ))}
        </li>
      ))}
    </ul>
  );
};
